module.exports = __webpack_public_path__ + "static/media/editIcon.d933786a.svg";